import { useEffect, useMemo, useState } from 'react';
import QRCode from 'qrcode';
import { env } from '../lib/env';

type Props = {
  path: string;
  alt?: string;
  size?: number;
};

function resolvePublicBaseUrl() {
  if (env.publicAppUrl) return env.publicAppUrl.replace(/\/$/, '');
  if (typeof window !== 'undefined' && window.location.origin && window.location.origin !== 'null') return window.location.origin;
  return '';
}

export function QrCodeImage({ path, alt = 'BelajarKu QR', size = 180 }: Props) {
  const [dataUrl, setDataUrl] = useState<string>('');
  const [error, setError] = useState<string>('');
  const payload = useMemo(() => {
    if (/^https?:\/\//i.test(path)) return path;
    const base = resolvePublicBaseUrl();
    return base ? `${base}${path.startsWith('/') ? '' : '/'}${path}` : path;
  }, [path]);

  useEffect(() => {
    let cancelled = false;
    setDataUrl(''); setError('');
    void QRCode.toDataURL(payload, { width: size, margin: 2, errorCorrectionLevel: 'M' })
      .then((url) => { if (!cancelled) setDataUrl(url); })
      .catch((cause) => { if (!cancelled) setError(cause instanceof Error ? cause.message : 'QR tidak dapat dibuat.'); });
    return () => { cancelled = true; };
  }, [payload, size]);

  if (error) return <div className="feedback feedback--error">QR gagal dibuat: {error}</div>;
  if (!dataUrl) return <div className="muted">Menyiapkan QR…</div>;

  return (
    <figure className="qr-code-image">
      <img src={dataUrl} width={size} height={size} alt={alt} />
      <figcaption>{payload}</figcaption>
    </figure>
  );
}
